// extracted by mini-css-extract-plugin
module.exports = {"Button":"src-screens-InsuranceContracts-List-components-PageHeader-style-module__Button--39Jey"};